import { CREDITS_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getCredits = (userId) => {
  return myFetch(`${CREDITS_ENDPOINT}/${userId}`, "GET");
};
